export const commonFr = {
  nav: {
    story: 'Notre Histoire',
    community: 'Communauté',
    transformation: 'Transformation',
    safety: 'Sécurité',
    blog: 'Blog',
    shop: 'Boutique',
    donate: 'Soutenir',
    volunteer: 'Bénévolat',
    resources: 'Ressources',
    crisisTracker: 'Suivi des Crises',
    partners: 'Partenaires',
    successStories: 'Histoires de Réussite',
  },
  // Navigation
  home: "Accueil",
  myStory: "Mon Histoire",
  community: "Communauté",
  shop: "Boutique",
  blog: "Blog",
  
  // Common buttons
  readMore: "Lire Plus",
  learnMore: "En Savoir Plus",
  joinNow: "Rejoindre",
  shopNow: "Acheter",
  subscribe: "S'abonner",
  submit: "Envoyer",
  
  // Footer
  quickLinks: "Liens Rapides",
  contact: "Contact",
  followUs: "Suivez-nous",
  allRightsReserved: "Tous droits réservés",
  
  // Newsletter
  newsletterTitle: "Rejoignez Notre Communauté",
  newsletterSubtitle: "Recevez l'inspiration et les mises à jour hebdomadaires dans votre boîte mail",
  emailPlaceholder: "Entrez votre email",
  
  // Common phrases
  byAuthor: "Par"
};

export default commonFr;
